<template>
  <div class="container">
    <!-- <div class="img-list flex flex-between">
      <div class="box flex flex-direction-column">
        <img src="~@/assets/case/park1-1.png" alt=""/>
        <div class="name">网络经济服务平台</div>
      </div>
      <div class="box flex flex-direction-column">
        <img src="~@/assets/case/park1-2.png" alt=""/>
        <div class="name">网络经济服务平台</div>
      </div>
    </div> -->
    <div class="info">
      无人机AI平台覆盖工业园区安全监测、农林水利生态保护、城市管理市容维护、道路交通隐患识别、乡镇街道设施巡查及应急救援灾情响应等六大领域，共72个场景。通过AI智能识别与实时监测，实现边坡塌陷预警、松材线虫检测、占道广告追踪、道路积水排查、危房隐患定位及山火快速响应，全面提升城乡治理效率与应急响应能力。
    </div>
    <div class="info">
      农业管理与病虫害监测
    </div>
    <div class="info">
      精准农业：通过多光谱相机分析作物健康状况，生成NDVI植被指数图，识别缺肥、缺水区域。例如，广西某镇使用无人机巡田，农药使用量减少30%，产量提升15%。
    </div>
    <div class="info">
      病虫害预警：热成像技术探测早期病害区域（如稻瘟病），AI模型比对历史数据，提前7-10天预警。
    </div>
    <div class="info">
      基础设施智能巡检
    </div>
    <div class="info">
      电力线路：无人机搭载激光雷达（LiDAR）扫描输电线，自动识别绝缘子破损、树障隐患。云南某县实现200公里线路巡检由2周缩短至3天。
    </div>
    <div class="info">
      水利设施：三维建模检测水库坝体裂缝（精度达毫米级），5G实时回传数据至指挥中心。
    </div>
    <div class="info">
      道路桥梁：倾斜摄影技术生成高精度三维模型，AI自动标注路面坑洞、护栏损坏。  
    </div>
    <div class="info">
      生态环境监管
    </div>
    <div class="info">
      污染溯源：每周固定航线巡查，通过气体传感器监测PM2.5/VOCs，结合风向模型定位违规排污企业。浙江某镇曾通过无人机热源追踪查获夜间偷排作坊。
    </div>
    <div class="info">
      河道治理：自动对比历史影像，识别河道侵占、非法采砂行为，定位精度达0.1米。
    </div>
    <div class="info">
      应急响应体系
    </div>
    <div class="info">
      山火防控：双光吊舱在火场上方500米实时测算火线蔓延速度，指挥直升机精准投水。
    </div>
    <div class="info">
      防汛巡查：洪水期自动沿预设路线飞行，激光测距实时监测堤坝水位，险情点定位误差＜1米。
    </div>
    <div class="info">
      物流领域
    </div>
    <div class="info">
      在物流领域，无人机通过“最后一公里”的快速配送解决方案，大幅缩短配送时间，尤其适合偏远地区。例如，亚马逊的Prime Air项目通过无人机实现30分钟内送货到家，无需人力，降低成本‌。此外，无人机在应急物资运输中也有重要应用，能够在灾害或紧急情况下迅速将药品、食品等应急物资运送至受灾地区或偏远地区。
    </div>
    <div class="info">
      影视与娱乐领域
    </div>
    <div class="info">
      无人机在影视制作中广泛应用于航拍与影视制作，提供独特的视角和动态画面，操作灵活且低成本替代直升机航拍。无人机还用于体育赛事、演唱会等大型活动的实时直播，带来全新的观赛体验。
    </div>
    <div class="info">
      安防与监控领域
    </div>
    <div class="info">
      无人机在安防与监控领域用于城市巡逻、交通监控和突发事件的实时监测，快速部署到目标区域并提供实时画面辅助决策。其在边境巡逻、森林防火和基础设施日常检查中也展现出卓越的巡检能力。
    </div>
    <div class="info">
      医疗与救援领域
    </div>
    <div class="info">
      无人机在医疗物资运送和搜索与救援中发挥重要作用。在偏远地区或灾难现场，无人机能快速、安全地运送疫苗、血液样本和药品，避开交通堵塞，确保物资快速到达需要的人手中。此外，无人机还可以在山区、海洋或灾害现场进行快速搜索与救援。
    </div>
    <div class="info">

    </div>
    <div class="info">

    </div>
    <div class="info">

    </div>
    <!-- <div class="flex flex-center bottom">
      <img class="img" src="~@/assets/case/park1-3.png" alt=""/>
      <div class="list">
        <div class="item" v-for="(item,index) in list" :class="'item' + index">
          <div :class="item.cls" class="content">
            {{ item.content }}
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {content: '为主管部门和企业搭建了 一座沟通便利的桥梁', cls: "text-right"},
        {content: '将各种服务资源有机整合'},
        {content: '为主管部门提供了一个 对外展示平台'},
        {content: '引导区内企业通过电子 商务手段转型'},
      ]
    }
  },
  methods: {},
  created() {

  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 500px;
  padding: 0 89px;
  background: url("~@/assets/case/product-detail-bg.png") no-repeat;
  background-position-y: bottom;
  background-size: contain;

  .box {
    img {
      margin-bottom: 10px;
    }

    .name {
      font-size: 18px;
      font-weight: 400;
      color: #333333;
      line-height: 21px;
      text-align: center;
    }
  }

  .img-list {
    margin-bottom: 40px;

    img {
      width: 582px;
      height: 350px;
    }
  }

  .info {
    font-size: 22px;
    font-weight: 400;
    color: #333333;
    line-height: 44px;
    margin-bottom: 50px;
    text-indent: 2em;

    .fw {
      font-weight: bold;
    }
  }

  .bottom {
    position: relative;
    margin-bottom: 50px;

    .img {
      width: 668px;
      height: 452px;
      margin-left: -10px;
    }

    .list {
      .item {
        font-size: 22px;
        font-weight: normal;
        color: #333333;
        line-height: 35px;
        position: absolute;

        .content {
          width: 247px;
          font-weight: bold;
        }
      }

      .item0 {
        left: 0;
        top: 25px;
      }

      .item1 {
        left: 0;
        bottom: 40px;
      }

      .item2 {
        right: 10px;
        top: 20px;
      }

      .item3 {
        right: 10px;
        bottom: 30px;
      }
    }

  }

}
</style>
